import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import { X } from '@phosphor-icons/react';
import { useEffect, useState } from 'react';
import StatementTable from './StatementTable';
import { getUserData } from 'js/library/utils/API/getUserData';
import cfac22 from 'js/library/utils/cfac22';

export default function StatementModal({ openStatement, setOpenStatement, userInfo }) {
  const partnerId = cfac22('partnerId');
  const [pointsBalance, setPointsBalance] = useState(null);

  useEffect(() => {
    //gravando ultimo path para retornar após login
    localStorage.setItem('lastURL', window.location.href);

    if (!userInfo.isGuest && openStatement) {
      getUserData({ identifier: userInfo.uId, type: 'uid', financial: true, partnerId })
        .then(({ financial }) => {
          setPointsBalance(financial.saldoCorrente.listaMovimentosRelacionados ?? {});
        })
        .catch(() => setPointsBalance('error'));
    }
  }, [openStatement, userInfo]);

  const style = {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
      xs: '100%',
      sm: '80%',
    },
    height: {
      xs: '100%',
      sm: '50%',
    },
    maxWidth: '1000px',
    minHeight: '300px',
    bgcolor: 'background.paper',
    boxShadow: 24,
  };

  return (
    <Box sx={style}>
      <span
        style={{
          background: 'white',
          color: '#6E3296',
          display: 'flex',
          padding: 10,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6">Extrato de pontos</Typography>
        <IconButton onClick={() => setOpenStatement(false)}>
          <X color="#000" weight="bold" />
        </IconButton>
      </span>
      <div
        style={{
          padding: 10,
          overflowY: 'scroll',
        }}
      >
        {pointsBalance === null && (
          <Box
            sx={{
              textAlign: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        )}

        {pointsBalance !== null && Object.keys(pointsBalance).length > 0 && (
          <StatementTable pointsBalance={pointsBalance} />
        )}
      </div>
    </Box>
  );
}

